/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Plant = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Plant 24">
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M5.991 8.01c-1.43-1.43-1.867-3.291-1.968-4.987 1.696.1 3.557.539 4.986 1.968 1.43 1.43 1.867 3.29 1.968 4.986-1.696-.1-3.557-.539-4.986-1.968ZM3.471 1c2.014.038 4.802.426 6.952 2.577A8.09 8.09 0 0 1 12 5.807a8.09 8.09 0 0 1 1.577-2.23c2.15-2.15 4.938-2.539 6.951-2.577A1.446 1.446 0 0 1 22 2.472c-.038 2.013-.426 4.8-2.577 6.951-1.968 1.968-4.47 2.46-6.423 2.559V13h5.5a1.5 1.5 0 0 1 1.5 1.5v2.257a1.5 1.5 0 0 1-.077.474l-1.581 4.743A1.5 1.5 0 0 1 16.919 23H7.08a1.5 1.5 0 0 1-1.423-1.026l-1.581-4.743A1.5 1.5 0 0 1 4 16.757V14.5A1.5 1.5 0 0 1 5.5 13H11v-1.018c-1.953-.099-4.455-.59-6.423-2.559C2.427 7.273 2.038 4.485 2 2.472A1.446 1.446 0 0 1 3.472 1ZM6 15v1h12v-1H6Zm11.558 3H6.442l1 3h9.116l1-3Zm2.42-14.977c-.102 1.696-.54 3.557-1.969 4.986-1.43 1.43-3.29 1.867-4.986 1.968.1-1.696.539-3.557 1.968-4.986 1.43-1.43 3.29-1.867 4.986-1.968Z"
        className="Union"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const PlantIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'plant-icon'}
      icon={Plant}
      {...props}
      size={size}
    />
  );
};
